import { useState } from 'react';
import SeoSchema from '../../components/SeoSchema';

const HomePage = () => {
  const [selectedPackage, setSelectedPackage] = useState('');
  const [showFAQ, setShowFAQ] = useState<number | null>(null);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    package: '',
    message: ''
  });

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    const form = e.target as HTMLFormElement;
    const formDataToSend = new FormData(form);
    
    try {
      const response = await fetch('https://readdy.ai/api/form/d4h836dtnoqs9bvm9on0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formDataToSend as any).toString()
      });
      
      if (response.ok) {
        alert('Cảm ơn bạn đã đăng ký! Chúng tôi sẽ liên hệ trong thời gian sớm nhất.');
        setFormData({ name: '', email: '', phone: '', package: '', message: '' });
      } else {
        alert('Có lỗi xảy ra, vui lòng thử lại sau.');
      }
    } catch (error) {
      alert('Có lỗi xảy ra, vui lòng thử lại sau.');
    }
  };

  const packages = [
    {
      title: 'Vòng Bảng Experience',
      price: 'Từ $2,500',
      matches: '2 trận vòng bảng',
      duration: '7-10 ngày',
      highlights: ['Vé trận đấu premium', 'Roadtrip 3 thành phố', 'Khách sạn 4 sao']
    },
    {
      title: 'Knockout Premium',
      price: 'Từ $6,200',
      matches: '1 trận tứ kết + 1 trận bán kết',
      duration: '10-12 ngày',
      highlights: ['Vé Premium', 'Roadtrip coast-to-coast', 'National Parks tour']
    },
    {
      title: 'Champion Package',
      price: 'Từ $12,500',
      matches: 'Bán kết + Chung kết',
      duration: '12-15 ngày',
      highlights: ['Vé premium tất cả trận', 'Luxury roadtrip', 'Exclusive experiences']
    }
  ];

  const roadtripRoutes = [
    {
      name: 'West Coast Adventure',
      route: 'Los Angeles → Las Vegas → Grand Canyon → San Francisco',
      duration: '8-10 ngày',
      image: 'https://public.readdy.ai/ai/img_res/efafbe7b7a2bf8bf2e1b775abfe2924d.jpg'
    },
    {
      name: 'East Coast Discovery',
      route: 'New York → Philadelphia → Washington DC → Boston',
      duration: '6-8 ngày',
      image: 'https://readdy.ai/api/search-image?query=American%20east%20coast%20roadtrip%20journey%20through%20iconic%20cities%20and%20autumn%20landscapes%2C%20luxury%20tour%20buses%20and%20RVs%20traveling%20past%20historic%20landmarks%2C%20golden%20fall%20foliage%2C%20metropolitan%20skylines%2C%20classic%20American%20highway%20adventure%20with%20modern%20vehicles%2C%20warm%20cinematic%20lighting&width=400&height=300&seq=eastcoast1&orientation=landscape'
    },
    {
      name: 'National Parks Explorer',
      route: 'Denver → Yellowstone → Yosemite → Utah Parks',
      duration: '12-14 ngày',
      image: 'https://readdy.ai/api/search-image?query=Epic%20American%20national%20parks%20roadtrip%20with%20luxury%20RVs%20and%20caravans%20driving%20through%20majestic%20mountain%20landscapes%2C%20pristine%20wilderness%2C%20towering%20redwood%20forests%2C%20crystal%20clear%20lakes%2C%20snow-capped%20peaks%2C%20adventurous%20outdoor%20exploration%2C%20cinematic%20natural%20beauty%2C%20golden%20hour%20lighting&width=400&height=300&seq=nationalparks1&orientation=landscape'
    }
  ];

  const faqs = [
    {
      question: 'Có cần visa Mỹ? Làm sao để xin?',
      answer: 'Có, bạn cần visa du lịch Mỹ (B1/B2). Chúng tôi sẽ hỗ trợ hồ sơ và hướng dẫn chi tiết quy trình xin visa.'
    },
    {
      question: 'Đảm bảo vé trận đấu như thế nào?',
      answer: 'Chúng tôi có đối tác chính thức với FIFA và các nhà cung cấp vé ủy quyền. Vé được đảm bảo 100% hoặc hoàn tiền.'
    },
    {
      question: 'Không biết lái xe có tham gia được không?',
      answer: 'Hoàn toàn được! Chúng tôi có tùy chọn xe bus luxury hoặc ghép nhóm với tài xế chuyên nghiệp.'
    },
    {
      question: 'Đi một mình có ghép đoàn không?',
      answer: 'Có, chúng tôi có dịch vụ ghép đoàn cho khách lẻ với những người Việt Nam cùng sở thích.'
    },
    {
      question: 'Tour có phù hợp với trẻ em không?',
      answer: 'Có, chúng tôi có gói gia đình với hoạt động phù hợp mọi lứa tuổi và chăm sóc đặc biệt cho trẻ em.'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <SeoSchema />
      {/* Hero Section */}
      <section className="relative h-screen flex items-center justify-center overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: `url('https://readdy.ai/api/search-image?query=Epic%20cinematic%20fusion%20of%20massive%20World%20Cup%202026%20soccer%20stadium%20filled%20with%20cheering%20fans%20and%20American%20highway%20roadtrip%20adventure%2C%20dramatic%20stadium%20lights%20mixing%20with%20golden%20sunset%20over%20endless%20highway%2C%20RV%20caravans%20and%20luxury%20buses%20traveling%20toward%20distant%20mountains%2C%20passionate%20football%20supporters%20wearing%20jerseys%2C%20red%20white%20blue%20American%20landscape%2C%20dynamic%20energy%20and%20adventure%20spirit%2C%20wide%20cinematic%20composition&width=1920&height=1080&seq=hero1&orientation=landscape')`
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-red-600/85 via-blue-700/80 to-green-600/75"></div>
        </div>
        
        <div className="relative z-10 container mx-auto px-6 text-center">
          <div className="max-w-4xl mx-auto">
            <div className="mb-6 inline-flex items-center bg-white text-red-600 px-4 py-2 rounded-full text-sm font-semibold">
              <i className="ri-fire-fill mr-2 text-red-600"></i>
              Số lượng giới hạn • Combo tour dành riêng cho khách Việt Nam
            </div>
            
            <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
              World Cup 2026 & USA Roadtrip
            </h1>
            <h2 className="text-2xl md:text-3xl text-white/95 mb-8 font-semibold">
              Sống trọn trận đấu, sống trọn cuộc phiêu lưu
            </h2>
            
            <p className="text-xl text-white/90 mb-10 max-w-2xl mx-auto leading-relaxed">
              Xem World Cup 2026 trực tiếp tại Mỹ và khám phá nước Mỹ qua hành trình roadtrip dành riêng cho người Việt
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button 
                onClick={() => document.getElementById('registration-form')?.scrollIntoView({ behavior: 'smooth' })}
                className="bg-white hover:bg-gray-100 text-red-600 px-8 py-4 rounded-lg text-lg font-bold transform hover:scale-105 transition-all duration-200 shadow-xl whitespace-nowrap cursor-pointer"
              >
                <i className="ri-football-fill mr-2"></i>
                Đăng ký ngay
              </button>
              <button 
                onClick={() => document.getElementById('packages')?.scrollIntoView({ behavior: 'smooth' })}
                className="bg-white/10 backdrop-blur-sm hover:bg-white/20 text-white border-2 border-white px-8 py-4 rounded-lg text-lg font-bold transform hover:scale-105 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-calendar-event-fill mr-2"></i>
                Nhận lịch thi đấu & báo giá
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Value Propositions */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-800 mb-6">Vì sao combo tour này khác biệt?</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Trải nghiệm độc nhất vô nhị kết hợp đam mê bóng đá với tinh thần khám phá
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="bg-white p-8 rounded-xl shadow-lg text-center transform hover:scale-105 transition-all duration-200">
              <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-trophy-fill text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-4">Vé World Cup trực tiếp</h3>
              <p className="text-gray-600">Vé xem trận đấu World Cup 2026 trực tiếp tại các sân vận động huyền thoại nước Mỹ</p>
            </div>
            
            <div className="bg-white p-8 rounded-xl shadow-lg text-center transform hover:scale-105 transition-all duration-200">
              <div className="w-16 h-16 bg-blue-700 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-roadster-fill text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-4">Roadtrip có hướng dẫn</h3>
              <p className="text-gray-600">Hành trình "phượt Mỹ" được dẫn đoàn chuyên nghiệp, an toàn và đầy thú vị</p>
            </div>
            
            <div className="bg-white p-8 rounded-xl shadow-lg text-center transform hover:scale-105 transition-all duration-200">
              <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-team-fill text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-4">Đội ngũ hỗ trợ Việt</h3>
              <p className="text-gray-600">Đội ngũ hỗ trợ người Việt tại Mỹ 24/7, giúp bạn yên tâm tận hưởng</p>
            </div>
            
            <div className="bg-white p-8 rounded-xl shadow-lg text-center transform hover:scale-105 transition-all duration-200">
              <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-settings-3-fill text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-4">Lịch trình linh hoạt</h3>
              <p className="text-gray-600">Phù hợp nhóm bạn, gia đình, cá nhân với nhiều tùy chọn tùy chỉnh</p>
            </div>
          </div>
          
          <div className="text-center mt-12">
            <button 
              onClick={() => document.getElementById('how-it-works')?.scrollIntoView({ behavior: 'smooth' })}
              className="bg-red-600 hover:bg-red-700 text-white px-8 py-4 rounded-lg text-lg font-bold transform hover:scale-105 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Xem cách combo tour hoạt động
            </button>
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section id="how-it-works" className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-800 mb-6">Combo Tour Vận Hành Thế Nào?</h2>
            <p className="text-xl text-gray-600">Quy trình đơn giản 5 bước để có chuyến đi trong mơ</p>
          </div>
          
          <div className="max-w-4xl mx-auto">
            <div className="relative">
              <div className="absolute left-8 top-0 bottom-0 w-1 bg-red-200"></div>
              
              <div className="space-y-12">
                {[
                  {
                    step: 1,
                    title: 'Chọn trận đấu & thành phố',
                    desc: 'Lựa chọn thành phố diễn ra World Cup và ngày xem trận yêu thích',
                    icon: 'ri-map-pin-fill'
                  },
                  {
                    step: 2,
                    title: 'Chọn tuyến roadtrip',
                    desc: 'Chọn tuyến roadtrip và số ngày khám phá theo sở thích',
                    icon: 'ri-route-fill'
                  },
                  {
                    step: 3,
                    title: 'Chúng tôi sắp xếp tất cả',
                    desc: 'Vé trận đấu, khách sạn, di chuyển và kế hoạch roadtrip chi tiết',
                    icon: 'ri-service-fill'
                  },
                  {
                    step: 4,
                    title: 'Bay sang Mỹ, tận hưởng',
                    desc: 'Gặp đoàn, tận hưởng bóng đá và cuộc phiêu lưu khám phá',
                    icon: 'ri-plane-fill'
                  },
                  {
                    step: 5,
                    title: 'Hỗ trợ suốt hành trình',
                    desc: 'Đội ngũ chăm sóc 24/7 để bạn yên tâm tận hưởng từng khoảnh khắc',
                    icon: 'ri-customer-service-2-fill'
                  }
                ].map((item) => (
                  <div key={item.step} className="relative flex items-center">
                    <div className="flex-shrink-0 w-16 h-16 bg-red-600 rounded-full flex items-center justify-center text-white font-bold text-xl relative z-10">
                      {item.step}
                    </div>
                    <div className="ml-8 bg-red-50 p-6 rounded-xl flex-1">
                      <div className="flex items-center mb-3">
                        <i className={`${item.icon} text-2xl text-red-600 mr-3`}></i>
                        <h3 className="text-xl font-bold text-gray-800">{item.title}</h3>
                      </div>
                      <p className="text-gray-600">{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          
          <div className="text-center mt-12">
            <button 
              onClick={() => document.getElementById('registration-form')?.scrollIntoView({ behavior: 'smooth' })}
              className="bg-gradient-to-r from-red-600 via-blue-700 to-green-600 hover:from-red-700 hover:via-blue-800 hover:to-green-700 text-white px-8 py-4 rounded-lg text-lg font-bold transform hover:scale-105 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Bắt đầu thiết kế chuyến World Cup Roadtrip của tôi
            </button>
          </div>
        </div>
      </section>

      {/* World Cup Packages */}
      <section id="packages" className="py-20 bg-gradient-to-br from-red-600 via-blue-700 to-green-600">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-white mb-6">Các Gói Xem World Cup 2026</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Lựa chọn gói phù hợp với ngân sách và đam mê của bạn
            </p>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
            {packages.map((pkg, index) => (
              <div key={index} className="bg-white rounded-xl overflow-hidden shadow-xl transform hover:scale-105 transition-all duration-200">
                <div className="bg-gradient-to-r from-red-600 to-orange-600 p-6 text-white text-center">
                  <h3 className="text-2xl font-bold mb-2">{pkg.title}</h3>
                  <div className="text-3xl font-bold">{pkg.price}</div>
                  <div className="text-red-200">{pkg.duration}</div>
                </div>
                
                <div className="p-6">
                  <div className="text-center mb-6">
                    <div className="text-lg font-semibold text-gray-800 mb-4">{pkg.matches}</div>
                    <ul className="space-y-2">
                      {pkg.highlights.map((highlight, idx) => (
                        <li key={idx} className="flex items-center text-gray-600">
                          <i className="ri-check-fill text-green-600 mr-2"></i>
                          {highlight}
                        </li>
                      ))}
                    </ul>
                  </div>
                  
                  <button 
                    onClick={() => {
                      setSelectedPackage(pkg.title);
                      document.getElementById('registration-form')?.scrollIntoView({ behavior: 'smooth' });
                    }}
                    className="w-full bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-lg font-bold transform hover:scale-105 transition-all duration-200 cursor-pointer"
                  >
                    Yêu cầu chi tiết gói trận đấu
                  </button>
                </div>
              </div>
            ))}
          </div>
          
          <div className="text-center mt-12">
            <button 
              onClick={() => document.getElementById('registration-form')?.scrollIntoView({ behavior: 'smooth' })}
              className="bg-white text-red-600 px-8 py-4 rounded-lg text-lg font-bold transform hover:scale-105 transition-all duration-200 shadow-xl whitespace-nowrap cursor-pointer"
            >
              Xem bảng giá & toàn bộ gói World Cup
            </button>
          </div>
        </div>
      </section>

      {/* Roadtrip Routes */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-800 mb-6">Roadtrip Mỹ & Trải nghiệm "Phượt Mỹ"</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Khám phá nước Mỹ theo phong cách tự do - từ xa lộ huyền thoại đến công viên quốc gia tuyệt đẹp
            </p>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8">
            {roadtripRoutes.map((route, index) => (
              <div key={index} className="bg-white rounded-xl overflow-hidden shadow-lg transform hover:scale-105 transition-all duration-200">
                <div className="relative h-64">
                  <img 
                    src={route.image}
                    alt={route.name}
                    className="w-full h-full object-cover object-top"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                  <div className="absolute bottom-4 left-4 text-white">
                    <div className="text-sm font-semibold">{route.duration}</div>
                  </div>
                </div>
                
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-800 mb-3">{route.name}</h3>
                  <p className="text-gray-600 mb-4">{route.route}</p>
                  <button 
                    onClick={() => document.getElementById('registration-form')?.scrollIntoView({ behavior: 'smooth' })}
                    className="w-full bg-orange-600 hover:bg-orange-700 text-white py-3 rounded-lg font-bold transform hover:scale-105 transition-all duration-200 cursor-pointer"
                  >
                    Xem chi tiết tuyến này
                  </button>
                </div>
              </div>
            ))}
          </div>
          
          <div className="text-center mt-12 space-y-4">
            <button 
              onClick={() => document.getElementById('registration-form')?.scrollIntoView({ behavior: 'smooth' })}
              className="bg-red-600 hover:bg-red-700 text-white px-8 py-4 rounded-lg text-lg font-bold transform hover:scale-105 transition-all duration-200 mr-4 whitespace-nowrap cursor-pointer"
            >
              Xem các tuyến roadtrip mẫu
            </button>
            <button 
              onClick={() => document.getElementById('registration-form')?.scrollIntoView({ behavior: 'smooth' })}
              className="bg-blue-700 hover:bg-blue-800 text-white px-8 py-4 rounded-lg text-lg font-bold transform hover:scale-105 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Nói chuyện với chuyên gia tư vấn
            </button>
          </div>
        </div>
      </section>

      {/* Sample Itinerary */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-800 mb-6">Lịch Trình Mẫu</h2>
            <p className="text-xl text-gray-600">Kết hợp hoàn hảo giữa trận đấu World Cup và roadtrip khám phá</p>
          </div>
          
          <div className="max-w-4xl mx-auto grid md:grid-cols-2 gap-8">
            <div className="bg-gradient-to-br from-blue-50 to-blue-100 p-8 rounded-xl">
              <div className="text-center mb-6">
                <h3 className="text-2xl font-bold text-blue-800">Gói 10 Ngày</h3>
                <p className="text-blue-600">2 trận World Cup + Roadtrip Tây Mỹ</p>
              </div>
              
              <ul className="space-y-3">
                <li className="flex items-center text-gray-700">
                  <i className="ri-calendar-check-fill text-blue-600 mr-3"></i>
                  Ngày 1-2: Bay đến Los Angeles, xem trận đầu
                </li>
                <li className="flex items-center text-gray-700">
                  <i className="ri-roadster-fill text-blue-600 mr-3"></i>
                  Ngày 3-5: Roadtrip LA → Las Vegas → Grand Canyon
                </li>
                <li className="flex items-center text-gray-700">
                  <i className="ri-football-fill text-blue-600 mr-3"></i>
                  Ngày 6-7: Xem trận thứ 2 tại San Francisco
                </li>
                <li className="flex items-center text-gray-700">
                  <i className="ri-camera-fill text-blue-600 mr-3"></i>
                  Ngày 8-9: Khám phá Silicon Valley & Napa Valley
                </li>
                <li className="flex items-center text-gray-700">
                  <i className="ri-plane-fill text-blue-600 mr-3"></i>
                  Ngày 10: Bay về Việt Nam
                </li>
              </ul>
            </div>
            
            <div className="bg-gradient-to-br from-red-50 to-red-100 p-8 rounded-xl">
              <div className="text-center mb-6">
                <h3 className="text-2xl font-bold text-red-800">Gói 14 Ngày</h3>
                <p className="text-red-600">2 trận World Cup + National Parks Experience</p>
              </div>
              
              <ul className="space-y-3">
                <li className="flex items-center text-gray-700">
                  <i className="ri-calendar-check-fill text-red-600 mr-3"></i>
                  Ngày 1-3: Salt Lake City + trận đấu đầu tiên
                </li>
                <li className="flex items-center text-gray-700">
                  <i className="ri-mountain-fill text-red-600 mr-3"></i>
                  Ngày 4-6: Roadtrip Yellowstone National Park
                </li>
                <li className="flex items-center text-gray-700">
                  <i className="ri-roadster-fill text-red-600 mr-3"></i>
                  Ngày 7-8: Denver & Rocky Mountains
                </li>
                <li className="flex items-center text-gray-700">
                  <i className="ri-football-fill text-red-600 mr-3"></i>
                  Ngày 9-10: Chicago + trận đấu thứ 2
                </li>
                <li className="flex items-center text-gray-700">
                  <i className="ri-roadster-fill text-red-600 mr-3"></i>
                  Ngày 11-12: Roadtrip đến East Coast
                </li>
                <li className="flex items-center text-gray-700">
                  <i className="ri-building-fill text-red-600 mr-3"></i>
                  Ngày 13-14: New York City & khám phá thành phố
                </li>
              </ul>
            </div>
          </div>
          
          <div className="text-center mt-12 space-x-4">
            <button 
              onClick={() => document.getElementById('registration-form')?.scrollIntoView({ behavior: 'smooth' })}
              className="bg-red-600 hover:bg-red-700 text-white px-8 py-4 rounded-lg text-lg font-bold transform hover:scale-105 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-download-fill mr-2"></i>
              Tải lịch trình chi tiết (PDF)
            </button>
            <button 
              onClick={() => document.getElementById('registration-form')?.scrollIntoView({ behavior: 'smooth' })}
              className="bg-blue-700 hover:bg-blue-800 text-white px-8 py-4 rounded-lg text-lg font-bold transform hover:scale-105 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-settings-3-fill mr-2"></i>
              Tùy chỉnh hành trình theo nhu cầu
            </button>
          </div>
        </div>
      </section>

      {/* Target Audience */}
      <section className="py-20 bg-gradient-to-r from-red-600 via-blue-700 to-green-600">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-white mb-6">Tour Này Phù Hợp Với Ai?</h2>
            <p className="text-xl text-green-100">Dành cho những ai muốn trải nghiệm độc đáo và đáng nhớ</p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-6xl mx-auto">
            {[
              {
                icon: 'ri-football-fill',
                title: 'Fan bóng đá cuồng nhiệt',
                desc: 'Muốn xem World Cup trực tiếp và cảm nhận khí thế sân vận động'
              },
              {
                icon: 'ri-group-fill',
                title: 'Nhóm bạn thích trải nghiệm',
                desc: 'Tìm kiếm những chuyến đi độc đáo và khó quên cùng bạn bè'
              },
              {
                icon: 'ri-home-heart-fill',
                title: 'Gia đình muốn kỷ niệm',
                desc: 'Tạo những kỷ niệm đẹp cho cả gia đình trong chuyến đi đặc biệt'
              },
              {
                icon: 'ri-briefcase-fill',
                title: 'Doanh nhân kết hợp công việc',
                desc: 'Kết hợp du lịch, networking và giải trí trong một chuyến đi'
              }
            ].map((item, index) => (
              <div key={index} className="bg-white/10 backdrop-blur-sm p-6 rounded-xl text-center transform hover:scale-105 transition-all duration-200">
                <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${item.icon} text-2xl text-white`}></i>
                </div>
                <h3 className="text-xl font-bold text-white mb-3">{item.title}</h3>
                <p className="text-white/80">{item.desc}</p>
              </div>
            ))}
          </div>
          
          <div className="text-center mt-12">
            <button 
              onClick={() => document.getElementById('registration-form')?.scrollIntoView({ behavior: 'smooth' })}
              className="bg-white text-red-600 px-8 py-4 rounded-lg text-lg font-bold transform hover:scale-105 transition-all duration-200 shadow-xl whitespace-nowrap cursor-pointer"
            >
              Xem tour có phù hợp với bạn không – Điền form
            </button>
          </div>
        </div>
      </section>

      {/* What's Included */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-800 mb-6">Bao Gồm & Không Bao Gồm</h2>
            <p className="text-xl text-gray-600">Thông tin chi tiết về dịch vụ trong gói tour</p>
          </div>
          
          <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-8">
            <div className="bg-white p-8 rounded-xl shadow-lg">
              <h3 className="text-2xl font-bold text-green-600 mb-6 flex items-center">
                <i className="ri-check-double-fill mr-3"></i>
                Bao Gồm
              </h3>
              
              <ul className="space-y-4">
                {[
                  'Vé trận đấu World Cup (tùy theo gói đã chọn)',
                  'Khách sạn tiêu chuẩn 3-4 sao suốt hành trình',
                  'Xe di chuyển (bus luxury hoặc cho thuê xe)',
                  'Bảo hiểm du lịch cơ bản',
                  'Hỗ trợ 24/7 từ đội ngũ tại Mỹ',
                  'Lập kế hoạch roadtrip chi tiết',
                  'Hướng dẫn viên người Việt',
                  'Một số bữa ăn nhóm đặc biệt'
                ].map((item, index) => (
                  <li key={index} className="flex items-start text-gray-700">
                    <i className="ri-check-fill text-green-600 mr-3 mt-1"></i>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
            
            <div className="bg-white p-8 rounded-xl shadow-lg">
              <h3 className="text-2xl font-bold text-red-600 mb-6 flex items-center">
                <i className="ri-close-circle-fill mr-3"></i>
                Không Bao Gồm
              </h3>
              
              <ul className="space-y-4">
                {[
                  'Vé máy bay quốc tế Việt Nam - Mỹ',
                  'Phần lớn các bữa ăn cá nhân',
                  'Chi phí mua sắm và giải trí cá nhân',
                  'Lệ phí xin visa Mỹ',
                  'Tiền tip cho tài xế và hướng dẫn viên',
                  'Bảo hiểm y tế và hành lý mở rộng',
                  'Phụ phí nâng cấp khách sạn',
                  'Chi phí phát sinh ngoài chương trình'
                ].map((item, index) => (
                  <li key={index} className="flex items-start text-gray-700">
                    <i className="ri-close-fill text-red-600 mr-3 mt-1"></i>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>
          
          <div className="text-center mt-12">
            <button 
              onClick={() => document.getElementById('registration-form')?.scrollIntoView({ behavior: 'smooth' })}
              className="bg-gradient-to-r from-red-600 via-blue-700 to-green-600 hover:from-red-700 hover:via-blue-800 hover:to-green-700 text-white px-8 py-4 rounded-lg text-lg font-bold transform hover:scale-105 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Xem chi tiết dịch vụ & báo giá chính xác
            </button>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-800 mb-6">Cảm Nhận Khách Hàng</h2>
            <p className="text-xl text-gray-600">Những trải nghiệm thật từ khách hàng đã tham gia tour</p>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
            {[
              {
                name: 'Anh Minh Trần',
                location: 'TP.HCM',
                rating: 5,
                comment: 'Chuyến đi tuyệt vời nhất đời! Được xem World Cup trực tiếp và khám phá nước Mỹ với phong cách roadtrip thật sự khó quên. Đội ngũ hỗ trợ rất chuyên nghiệp.',
                image: 'https://readdy.ai/api/search-image?query=Happy%20Vietnamese%20man%20in%20his%2030s%20wearing%20Vietnam%20national%20team%20soccer%20jersey%20at%20American%20stadium%2C%20smiling%20and%20cheering%20with%20stadium%20crowd%20in%20background%2C%20excited%20football%20fan%20celebration%2C%20warm%20cinematic%20lighting&width=150&height=150&seq=testimonial1&orientation=squarish'
              },
              {
                name: 'Chị Lan Nguyễn',
                location: 'Hà Nội',
                rating: 5,
                comment: 'Gia đình tôi có kỷ niệm đẹp nhất. Các con rất thích roadtrip qua các công viên quốc gia, còn chồng tôi thì phấn khích với trận đấu. Tour được tổ chức rất chu đáo.',
                image: 'https://readdy.ai/api/search-image?query=Happy%20Vietnamese%20woman%20in%20her%2030s%20with%20family%20at%20Grand%20Canyon%20during%20American%20roadtrip%2C%20wearing%20casual%20travel%20clothes%2C%20big%20smile%2C%20beautiful%20natural%20landscape%20background%2C%20family%20vacation%20photography%20style&width=150&height=150&seq=testimonial2&orientation=squarish'
              },
              {
                name: 'Nhóm bạn VN United',
                location: 'Đà Nẵng',
                rating: 5,
                comment: 'Nhóm 8 bạn thân đi cùng nhau. Roadtrip từ LA đến Vegas thật sự epic! Được xem 2 trận World Cup và có hàng nghìn ảnh đẹp. Sẽ đi tiếp các tour khác.',
                image: 'https://readdy.ai/api/search-image?query=Group%20of%20young%20Vietnamese%20friends%20taking%20selfie%20with%20American%20highway%20and%20desert%20landscape%20in%20background%20during%20roadtrip%2C%20wearing%20soccer%20jerseys%20and%20casual%20clothes%2C%20happy%20group%20travel%20photography%2C%20golden%20hour%20lighting&width=150&height=150&seq=testimonial3&orientation=squarish'
              }
            ].map((testimonial, index) => (
              <div key={index} className="bg-gray-50 p-6 rounded-xl shadow-lg">
                <div className="flex items-center mb-4">
                  <img 
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-16 h-16 rounded-full object-cover object-top mr-4"
                  />
                  <div>
                    <h4 className="font-bold text-gray-800">{testimonial.name}</h4>
                    <p className="text-gray-600 text-sm">{testimonial.location}</p>
                    <div className="flex text-yellow-500">
                      {[...Array(testimonial.rating)].map((_, i) => (
                        <i key={i} className="ri-star-fill"></i>
                      ))}
                    </div>
                  </div>
                </div>
                <p className="text-gray-700 italic">"{testimonial.comment}"</p>
              </div>
            ))}
          </div>
          
          <div className="text-center mt-12">
            <button 
              onClick={() => document.getElementById('registration-form')?.scrollIntoView({ behavior: 'smooth' })}
              className="bg-gradient-to-r from-red-600 via-blue-700 to-green-600 hover:from-red-700 hover:via-blue-800 hover:to-green-700 text-white px-8 py-4 rounded-lg text-lg font-bold transform hover:scale-105 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Tham gia nhóm Roadtrip World Cup tiếp theo
            </button>
          </div>
        </div>
      </section>

      {/* Video Section */}
      <section className="py-20 bg-gradient-to-br from-gray-800 to-gray-900">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-white mb-6">Cảm Nhận Không Khí Thật</h2>
            <p className="text-xl text-gray-300">Video trực tiếp từ các chuyến roadtrip trước đây</p>
          </div>
          
          <div className="max-w-4xl mx-auto">
            <div className="aspect-video bg-gray-700 rounded-xl overflow-hidden shadow-2xl">
              <iframe 
                src="https://www.youtube.com/embed/8uX2e63hVXk"
                width="100%"
                height="100%"
                style={{ border: 'none', overflow: 'hidden' }}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen={true}
                className="w-full h-full"
              ></iframe>
            </div>
            
            <div className="text-center mt-8">
              <button 
                onClick={() => document.getElementById('registration-form')?.scrollIntoView({ behavior: 'smooth' })}
                className="bg-white text-gray-900 px-8 py-4 rounded-lg text-lg font-bold transform hover:scale-105 transition-all duration-200 shadow-xl whitespace-nowrap cursor-pointer"
              >
                Xem thêm video & highlight
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-800 mb-6">Câu Hỏi Thường Gặp</h2>
            <p className="text-xl text-gray-600">Giải đáp mọi thắc mắc của bạn về tour</p>
          </div>
          
          <div className="max-w-4xl mx-auto space-y-4">
            {faqs.map((faq, index) => (
              <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden">
                <button 
                  onClick={() => setShowFAQ(showFAQ === index ? null : index)}
                  className="w-full p-6 text-left flex items-center justify-between hover:bg-gray-50 cursor-pointer"
                >
                  <h3 className="text-lg font-bold text-gray-800">{faq.question}</h3>
                  <i className={`ri-arrow-${showFAQ === index ? 'up' : 'down'}-s-fill text-blue-600 text-xl`}></i>
                </button>
                {showFAQ === index && (
                  <div className="px-6 pb-6">
                    <p className="text-gray-600">{faq.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
          
          <div className="text-center mt-12">
            <button 
              onClick={() => document.getElementById('registration-form')?.scrollIntoView({ behavior: 'smooth' })}
              className="bg-red-600 hover:bg-red-700 text-white px-8 py-4 rounded-lg text-lg font-bold transform hover:scale-105 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Vẫn còn câu hỏi? Liên hệ ngay
            </button>
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-20 bg-gradient-to-r from-red-600 via-blue-700 to-green-600">
        <div className="container mx-auto px-6 text-center">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-5xl font-bold text-white mb-6">
              Bạn Đã Sẵn Sàng Sống Trọn Giấc Mơ World Cup 2026 Tại Mỹ Chưa?
            </h2>
            <p className="text-xl text-white/90 mb-10 max-w-2xl mx-auto">
              Đừng bỏ lỡ cơ hội duy nhất để trải nghiệm World Cup và khám phá nước Mỹ theo cách chưa từng có
            </p>
            
            <button 
              onClick={() => document.getElementById('registration-form')?.scrollIntoView({ behavior: 'smooth' })}
              className="bg-white text-red-600 px-12 py-6 rounded-xl text-2xl font-bold transform hover:scale-105 transition-all duration-200 shadow-2xl whitespace-nowrap cursor-pointer"
            >
              <i className="ri-rocket-fill mr-3"></i>
              Đăng ký ngay – Điền form bên dưới
            </button>
            
            <div className="mt-8 text-white/80">
              <p>⏰ Số lượng có giới hạn - Chỉ còn vài suất cuối cùng!</p>
            </div>
          </div>
        </div>
      </section>

      {/* Registration Form */}
      <section id="registration-form" className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="max-w-2xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold text-gray-800 mb-6">Đăng Ký Tham Gia Tour</h2>
              <p className="text-xl text-gray-600">
                Điền thông tin để nhận báo giá chi tiết và tư vấn miễn phí
              </p>
            </div>
            
            <form onSubmit={handleSubmit} className="bg-gray-50 p-8 rounded-xl shadow-lg space-y-6" data-readdy-form>
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-gray-700 font-semibold mb-2">Họ và tên *</label>
                  <input 
                    type="text"
                    name="name"
                    required
                    value={formData.name}
                    onChange={(e) => setFormData({...formData, name: e.target.value})}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600 focus:border-transparent text-sm"
                    placeholder="Nhập họ và tên của bạn"
                  />
                </div>
                
                <div>
                  <label className="block text-gray-700 font-semibold mb-2">Email *</label>
                  <input 
                    type="email"
                    name="email"
                    required
                    value={formData.email}
                    onChange={(e) => setFormData({...formData, email: e.target.value})}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600 focus:border-transparent text-sm"
                    placeholder="email@example.com"
                  />
                </div>
              </div>
              
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-gray-700 font-semibold mb-2">Số điện thoại *</label>
                  <input 
                    type="tel"
                    name="phone"
                    required
                    value={formData.phone}
                    onChange={(e) => setFormData({...formData, phone: e.target.value})}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600 focus:border-transparent text-sm"
                    placeholder="0901234567"
                  />
                </div>
                
                <div>
                  <label className="block text-gray-700 font-semibold mb-2">Gói tour quan tâm</label>
                  <select 
                    name="package"
                    value={selectedPackage || formData.package}
                    onChange={(e) => setFormData({...formData, package: e.target.value})}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600 focus:border-transparent text-sm pr-8"
                  >
                    <option value="">Chọn gói tour</option>
                    <option value="Vòng Bảng Experience">Vòng Bảng Experience</option>
                    <option value="Knockout Premium">Knockout Premium</option>
                    <option value="Champion Package">Champion Package</option>
                    <option value="Tùy chỉnh theo nhu cầu">Tùy chỉnh theo nhu cầu</option>
                  </select>
                </div>
              </div>
              
              <div>
                <label className="block text-gray-700 font-semibold mb-2">Ghi chú thêm</label>
                <textarea 
                  name="message"
                  rows={4}
                  maxLength={500}
                  value={formData.message}
                  onChange={(e) => setFormData({...formData, message: e.target.value})}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600 focus:border-transparent text-sm resize-none"
                  placeholder="Chia sẻ thêm về nhu cầu, số người tham gia, thời gian mong muốn... (tối đa 500 ký tự)"
                ></textarea>
                <div className="text-right text-sm text-gray-500 mt-1">
                  {formData.message.length}/500 ký tự
                </div>
              </div>
              
              <button 
                type="submit"
                className="w-full bg-gradient-to-r from-red-600 via-blue-700 to-green-600 hover:from-red-700 hover:via-blue-800 hover:to-green-700 text-white py-4 rounded-lg text-lg font-bold transform hover:scale-105 transition-all duration-200 shadow-xl whitespace-nowrap cursor-pointer"
              >
                <i className="ri-send-plane-fill mr-2"></i>
                Gửi đăng ký ngay
              </button>

              <p className="text-center text-gray-600 text-sm">
                Bằng việc đăng ký, bạn đồng ý với <strong>Điều khoản sử dụng</strong> và <strong>Chính sách bảo mật</strong> của chúng tôi
              </p>
            </form>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="container mx-auto px-6">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <h3 className="text-2xl font-bold mb-4" style={{fontFamily: '"Pacifico", serif'}}>WorldCup Roadtrip</h3>
              <p className="text-gray-300 mb-4">
                Chuyên tổ chức tour roadtrip khám phá nước Mỹ & mùa World Cup 2026 kết hợp dành riêng cho người Việt Nam.
              </p>
              <div className="flex space-x-4">
                <a href="#" className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center hover:bg-blue-700 transition-colors cursor-pointer">
                  <i className="ri-facebook-fill"></i>
                </a>
                <a href="#" className="w-10 h-10 bg-red-600 rounded-full flex items-center justify-center hover:bg-red-700 transition-colors cursor-pointer">
                  <i className="ri-youtube-fill"></i>
                </a>
                <a href="#" className="w-10 h-10 bg-pink-600 rounded-full flex items-center justify-center hover:bg-pink-700 transition-colors cursor-pointer">
                  <i className="ri-instagram-fill"></i>
                </a>
                <a href="#" className="w-10 h-10 bg-gray-700 rounded-full flex items-center justify-center hover:bg-gray-600 transition-colors cursor-pointer">
                  <i className="ri-tiktok-fill"></i>
                </a>
              </div>
            </div>
            
            <div>
              <h4 className="text-lg font-bold mb-4">Liên hệ</h4>
              <div className="space-y-2 text-gray-300">
                <p><i className="ri-phone-fill mr-2"></i> 0889992466 / 1 714 552 1068</p>
                <p><i className="ri-mail-fill mr-2"></i> info@khamphamy.vn</p>
                <p><i className="ri-map-pin-fill mr-2"></i> Hà Nội - Việt Nam</p>
                <p><i className="ri-map-pin-fill mr-2"></i> California - Hoa Kỳ</p>
              </div>
            </div>
            
            <div>
              <h4 className="text-lg font-bold mb-4">Dịch vụ</h4>
              <ul className="space-y-2 text-gray-300">
                <li><a href="#packages" className="hover:text-white cursor-pointer">Gói World Cup</a></li>
                <li><a href="#" className="hover:text-white cursor-pointer">Roadtrip Mỹ</a></li>
                <li><a href="#" className="hover:text-white cursor-pointer">Visa Mỹ</a></li>
                <li><a href="#" className="hover:text-white cursor-pointer">Bảo hiểm du lịch</a></li>
              </ul>
            </div>
            
            <div>
              <h4 className="text-lg font-bold mb-4">Thông tin</h4>
              <ul className="space-y-2 text-gray-300">
                <li><a href="#" className="hover:text-white cursor-pointer">Giới thiệu</a></li>
                <li><a href="#" className="hover:text-white cursor-pointer">Điều khoản</a></li>
                <li><a href="#" className="hover:text-white cursor-pointer">Chính sách bảo mật</a></li>
                <li><a href="#" className="hover:text-white cursor-pointer">Liên hệ</a></li>
              </ul>
            </div>
          </div>
          
          <div className="border-t border-gray-700 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400">© 2024 WorldCup Roadtrip. All rights reserved.</p>
            <a href="https://readdy.ai/?origin=logo" className="text-gray-400 hover:text-white mt-4 md:mt-0 cursor-pointer">
              Powered by Readdy
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default HomePage;
